import Dialog from '@mui/material/Dialog';

import './index.less';
import useConfig from 'hooks/useConfig';

const KeyFormDialog = (props: { open: boolean; handleClose: () => void }) => {
    const { open, handleClose } = props;
    const { locale } = useConfig();
    const handleCloseDialog = () => {
        handleClose();
    };

    return (
        <Dialog
            open={open}
            PaperProps={{
                sx: {
                    padding: 0,
                    backgroundColor: 'transparent',
                    boxShadow: 'none'
                }
            }}
            sx={{ p: 0, border: 'none' }}
            maxWidth={false}
            onClose={handleCloseDialog}
        >
            <section className={locale === 'en' ? 'en-promotion-dialog' : locale === 'tc' ? 'tc-promotion-dialog' : 'promotion-dialog'}>
                <div style={{ width: '60px', height: '70px', cursor: 'pointer' }} onClick={handleCloseDialog}></div>
            </section>
        </Dialog>
    );
};
export default KeyFormDialog;
